import { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import Context from "../../Context";

const CardHisto2 = () => {
  const { histoClinica, showIcons } = useContext(Context);

  // TEXT AREA ocupacion

  const localOcupacion = JSON.parse(localStorage.getItem("localOcupacion"));

  const [ocupacion, setOcupacion] = useState(localOcupacion);

  const handleOcupacion = (event) => {
    const inputOcupacion = event.target.value;
    setOcupacion(inputOcupacion);
    /* histoClinica.ocupacion = inputOcupacion; */

    localStorage.setItem("localOcupacion", JSON.stringify(inputOcupacion));
  };

  // TEXT AREA deportes
  const localDeportes = JSON.parse(localStorage.getItem("localDeportes"));

  const [deportes, setDeportes] = useState(localDeportes);

  const handleDeportes = (event) => {
    const inputDeportes = event.target.value;
    setDeportes(inputDeportes);
    histoClinica.deportes = inputDeportes;

    localStorage.setItem("localDeportes", JSON.stringify(inputDeportes));
  };
  // TEXT AREA tratamientosActuales
  const localTratamientosActuales = JSON.parse(
    localStorage.getItem("localTratamientosActuales")
  );

  const [tratamientosActuales, setTratamientosActuales] = useState(
    localTratamientosActuales
  );

  const handleTratamientosActuales = (event) => {
    const inputTratamientosActuales = event.target.value;
    setTratamientosActuales(inputTratamientosActuales);
    histoClinica.tratamientosActuales = inputTratamientosActuales;

    localStorage.setItem(
      "localTratamientosActuales",
      JSON.stringify(inputTratamientosActuales)
    );
  };
  // TEXT AREA otrosSintomas
  const localOtroSintomas = JSON.parse(
    localStorage.getItem("localOtroSintomas")
  );

  const [otrosSintomas, setOtrosSintomas] = useState(localOtroSintomas);

  const handleOtrosSintomas = (event) => {
    const inputOtrosSintomas = event.target.value;
    setOtrosSintomas(inputOtrosSintomas);
    histoClinica.otrosSintomas = inputOtrosSintomas;

    localStorage.setItem(
      "localOtroSintomas",
      JSON.stringify(inputOtrosSintomas)
    );
  };

  const handleDeleteForm = () => {
    localStorage.removeItem(
      "localOcupacion",
      "localDeportes",
      "localTratamientosActuales",
      "localOtroSintomas"
    );
    setOcupacion("");
    setDeportes("");
    setTratamientosActuales("");
    setOtrosSintomas("");
  };
  return (
    <>
      <div className="column">
        <div className="card-section">
          <div style={{ /*  width: 400, */ margin: 20 }}>
            <h4 className="text-center">Anamnesis 1.2</h4>
            <br />
            <h6>Ocupación</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={ocupacion}
              onChange={handleOcupacion}
            />

            <h6 className="mt-2">Deportes / Actividad Física</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={deportes}
              onChange={handleDeportes}
            />

            <h6 className="mt-2">Tratamientos actuales y / o anteriores</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={tratamientosActuales}
              onChange={handleTratamientosActuales}
            />

            <h6 className="mt-2">Otros síntomas</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={otrosSintomas}
              onChange={handleOtrosSintomas}
            />
          </div>
        </div>
        {showIcons && (
          <div className="icons-card-canvas mb-5">
            <img
              className="icon-trash-canvas"
              src="/assets/images/trash.png"
              alt="icon-image"
              onClick={handleDeleteForm}
            />
            {/* <img
            className="icon-trash-canvas"
            src="/assets/images/icon-download.png"
            alt="icon-image"
            onClick={() => alert("Imagen guardada")}
          /> */}
          </div>
        )}
      </div>
    </>
  );
};

export default CardHisto2;
